import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
import { DROPDOWN_LIST_HEIGHT, ROW_SIZE } from "../constants";
import { CustomEditSpan, DropdownItem, DropdownWrapper, EditOptionButton, OptionRow } from "../styles";
import { CreateNewOptionButton } from "./CreateNewOptionButton";
import { getLabel, getValue } from "./utils";
export var DropdownContent = function(param) {
    var closeDropdown = param.closeDropdown, containingElement = param.containingElement, createNewOption = param.createNewOption, filteredOptions = param.filteredOptions, helper = param.helper, highlightIndex = param.highlightIndex, isCustomOption = param.isCustomOption, onCustomOptionEdit = param.onCustomOptionEdit, onHighlight = param.onHighlight, onSelect = param.onSelect, open = param.open, options = param.options, refs = param.refs, searchValue = param.searchValue, resetSearchValue = param.resetSearchValue, showErrorMessage = param.showErrorMessage, targetRef = param.targetRef, isPortal = param.isPortal;
    // Returns true if the dropdown should open up, false otherwise.
    var isUp = React.useMemo(function() {
        var _targetRef_current, _targetRef_current1, _containingElement_getBoundingClientRect, _getWindow;
        var sizeOfDropdown = ROW_SIZE * Math.min(DROPDOWN_LIST_HEIGHT / ROW_SIZE, options.length);
        var potentialBottom = (_targetRef_current = targetRef.current) === null || _targetRef_current === void 0 ? void 0 : _targetRef_current.getBoundingClientRect().top;
        var potentialTop = (_targetRef_current1 = targetRef.current) === null || _targetRef_current1 === void 0 ? void 0 : _targetRef_current1.getBoundingClientRect().bottom;
        if (potentialBottom === undefined || potentialTop === undefined) {
            return false;
        }
        // If we're going to go above the screen, it's better to go down
        if (potentialBottom - sizeOfDropdown < 0) {
            return false;
        }
        var _containingElement_getBoundingClientRect_bottom, _ref;
        return potentialTop + sizeOfDropdown > ((_ref = (_containingElement_getBoundingClientRect_bottom = containingElement === null || containingElement === void 0 ? void 0 : (_containingElement_getBoundingClientRect = containingElement.getBoundingClientRect()) === null || _containingElement_getBoundingClientRect === void 0 ? void 0 : _containingElement_getBoundingClientRect.bottom) !== null && _containingElement_getBoundingClientRect_bottom !== void 0 ? _containingElement_getBoundingClientRect_bottom : (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.innerHeight) !== null && _ref !== void 0 ? _ref : 0);
    }, [
        options.length,
        targetRef,
        containingElement
    ]);
    var handleCustomOptionEdit = React.useCallback(function(event) {
        event.preventDefault();
        onCustomOptionEdit();
    }, [
        onCustomOptionEdit
    ]);
    var handleItemSelect = React.useCallback(function(event, index) {
        event.preventDefault();
        onSelect(index);
    }, [
        onSelect
    ]);
    return /*#__PURE__*/ _jsxs(DropdownWrapper, {
        "data-test-id": "dropdown_wrapper",
        $showErrorMessage: showErrorMessage,
        $hasHelper: !!helper,
        $isOpen: open,
        $isUp: isUp,
        $isPortal: isPortal,
        role: "listbox",
        "aria-multiselectable": false,
        children: [
            filteredOptions.map(function(option, index) {
                var label = getLabel(option);
                var value = getValue(option);
                var isSelected = index === highlightIndex;
                var isCustom = isCustomOption(option);
                var _option_onClick;
                return /*#__PURE__*/ _jsxs(OptionRow, {
                    $highlight: isSelected,
                    align: "center",
                    onMouseOver: function() {
                        return onHighlight(index);
                    },
                    children: [
                        /*#__PURE__*/ _jsx(DropdownItem, {
                            role: "option",
                            ref: function(el) {
                                if (!el) {
                                    return;
                                }
                                refs.current[index] = el;
                            },
                            tabIndex: -1,
                            $isCustom: isCustom && option.hasEdited,
                            onClick: isCustom ? (_option_onClick = option.onClick) !== null && _option_onClick !== void 0 ? _option_onClick : option.hasEdited ? function(event) {
                                return handleItemSelect(event, index);
                            } : handleCustomOptionEdit : undefined,
                            onMouseDown: isCustom ? undefined : function(event) {
                                return handleItemSelect(event, index);
                            },
                            onMouseOver: function() {
                                return onHighlight(index);
                            },
                            "data-test-id": "dropdownItem_".concat(value),
                            type: "button",
                            "aria-selected": isSelected,
                            disabled: option.disabled,
                            children: label
                        }),
                        isCustom && option.hasEdited ? /*#__PURE__*/ _jsx(EditOptionButton, {
                            onClick: handleCustomOptionEdit,
                            onMouseOver: function() {
                                return onHighlight(index);
                            },
                            "data-test-id": "custom_dropdownItem_".concat(value),
                            type: "button",
                            "aria-selected": isSelected,
                            children: /*#__PURE__*/ _jsx(CustomEditSpan, {
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "A9S+QJ",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Edit"
                                        }
                                    ]
                                })
                            })
                        }) : null
                    ]
                }, "".concat(label, " ").concat(index));
            }),
            /*#__PURE__*/ _jsx(CreateNewOptionButton, {
                createNewOption: createNewOption,
                searchValue: searchValue,
                filteredOptions: filteredOptions,
                highlightIndex: highlightIndex,
                onHighlight: onHighlight,
                closeDropdown: closeDropdown,
                resetSearchValue: resetSearchValue,
                refs: refs
            })
        ]
    });
};
